export const MANAGE_CONTACT_MODAL_TEXTS = {
  tooltips: {
    serviceProvider: 'This contact has a service provider account in Anchor and therefore only they can update their own contact details.',
    multiVendor: 'This contact is linked to multiple service providers in Anchor. As a result, only they can update their email address.'
  },
  helperText: {
    phoneNumber: 'Add a phone number to enable text reminders'
  }
};